<div class="discount-manager">
  <h3>DISCOUNT / PROMO MANAGER</h3>
  <p class="hint">Discounts are reportable by type. Inactive codes cannot be applied at checkout.</p>

  <div class="draft-row">
    <mat-form-field>
      <mat-label>NAME</mat-label>
      <input matInput [(ngModel)]="draft.name" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>TYPE</mat-label>
      <mat-select [(ngModel)]="draft.type">
        <mat-option value="PERCENT">Percentage</mat-option>
        <mat-option value="FIXED">Fixed Dollar Amount</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>VALUE</mat-label>
      <input matInput type="number" [(ngModel)]="draft.value">
    </mat-form-field>
    <button mat-raised-button type="button" [disabled]="saving" (click)="add()">ADD</button>
  </div>

  <table class="discount-table">
    <tr *ngFor="let discount of discounts">
      <td>
        <mat-form-field>
          <input matInput [(ngModel)]="discount.name">
        </mat-form-field>
      </td>
      <td>
        <mat-select [(ngModel)]="discount.type">
          <mat-option value="PERCENT">Percentage</mat-option>
          <mat-option value="FIXED">Fixed Dollar Amount</mat-option>
        </mat-select>
      </td>
      <td>
        <mat-form-field>
          <input matInput type="number" [(ngModel)]="discount.value">
        </mat-form-field>
      </td>
      <td>
        <mat-slide-toggle [(ngModel)]="discount.active">ACTIVE</mat-slide-toggle>
      </td>
      <td>
        <button mat-stroked-button type="button" [disabled]="saving" (click)="save(discount)">SAVE</button>
      </td>
    </tr>
  </table>
</div>
